import { Box, Grid, Hidden, Chip } from "@mui/material";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import PhotoLibrary from "@mui/icons-material/PhotoLibrary";
import PhoneIcon from "@mui/icons-material/Phone";
import NoteIcon from "@mui/icons-material/Note";
import DescriptionIcon from "@mui/icons-material/Description";
import useStyles from "../../../components/profile-detail/style";
import Details from "../../../components/profile-detail/details";
import Gallery from "../../../components/profile-detail/gallery";
import Contact from "../../../components/profile-detail/contact";
import Actions from "../../../components/profile-detail/actions";
import Notes from "./notes";
import { useNavigate } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { useLocalState } from "../../../hooks";
import { useSelector } from "react-redux";
import Api from "../../../store/api";

export default function ViewProfile() {
  const classes = useStyles();
  const navigate = useNavigate();
  const selectedProfile = sessionStorage.getItem('selectedProfile');
  const user = useMemo(() => {
    if (!selectedProfile) return null;
    try {
      return JSON.parse(selectedProfile);
    } catch (e) {
      return null;
    }
  }, [selectedProfile]);
  const viewedUserId = user?.id;
  const [LS, setLS] = useLocalState({ tabValue: "1", interestStatus: null as any });
  const authUserId = useSelector((state: any) => state.auth?.user?.id);

  useEffect(() => {
    if (!viewedUserId) navigate('/');
  }, [viewedUserId, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [viewedUserId]);

  useEffect(() => {
    const fetchInterestStatus = async () => {
      if (viewedUserId && authUserId) {
        try {
          const response = await Api.getInterest(authUserId, viewedUserId);
          if (response?.data?.data) {
            setLS({ interestStatus: response.data.data });
          }
        } catch (error) {
          console.log('Error fetching interest status:', error);
        }
      }
    };
    fetchInterestStatus();
  }, [viewedUserId, authUserId]);

  const switchTab = (event: any, newValue: any) => {
    setLS({ tabValue: newValue });
  };
  
  const getStatusColor = (state: string) => {
    switch (state) {
      case 'SENT': return 'warning';
      case 'VIEWED': return 'info';
      case 'ACCEPTED': return 'success';
      case 'REJECTED': return 'error';
      default: return 'default';
    }
  };

  const formatDate = (dateString: string | null) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const getInterestDate = (interest: any) => {
    if (!interest) return null;
    if (interest.state === 'VIEWED') return interest.viewedAt || interest.createdAt;
    if (interest.state === 'ACCEPTED') return interest.acceptedAt || interest.createdAt;
    if (interest.state === 'REJECTED') return interest.rejectedAt || interest.createdAt;
    return interest.createdAt;
  };

  return (
    <>
      <Hidden mdUp>
        <Box sx={{ height: "50px" }} />
      </Hidden>
      <Paper elevation={0} className={classes.paper}>
        {user && <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <Avatar
              alt="Profile Image"
              src={user?.img}
              sx={{ width: 100, height: 100, margin: "auto" }}
            />
            {/* Profile Details Content */}
            <Typography align="center" variant="h6">
              {user?.memberId}
            </Typography>
            
            {LS.interestStatus && (
              <Box sx={{ textAlign: 'center', mt: 2, mb: 1 }}>
                <Chip
                  label={`Interest ${LS.interestStatus.state} on ${formatDate(getInterestDate(LS.interestStatus))}`}
                  color={getStatusColor(LS.interestStatus.state) as any}
                  variant="outlined"
                />
              </Box>
            )}

            <TabContext value={LS.tabValue}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={switchTab}
                  aria-label="lab API tabs example"
                  className={classes.tabList}
                  centered
                >
                  <Tab icon={<DescriptionIcon />} value="1" />
                  <Tab icon={<PhotoLibrary />} value="2" />
                  <Tab icon={<PhoneIcon />} value="3" />
                  <Tab icon={<NoteIcon />} value="4" />
                </TabList>
              </Box>
              <TabPanel value="1">
                <Details profileData={user} />
                <Box className={classes.blank}></Box>
              </TabPanel>
              <TabPanel value="2">
                <Gallery user={user} />
                <Box className={classes.blank}></Box>
              </TabPanel>
              <TabPanel value="3">
                <Contact user={user} />
              </TabPanel>
              <TabPanel value="4">
                <Notes user={user} />
              </TabPanel>
            </TabContext>
          </Grid>
        </Grid>}
      </Paper>
      <Actions />
    </>
  );
}
